import React from 'react';
import moment from 'moment-timezone';
import formatCurrency from 'utils/formatCurrency';

export const toThinLine = () => {
  return (
    <hr style={{
      height: "1px",
      border: "1px solid #D3D3D3",
      borderRadius: "5px 5px 5px 5px",
      backgroundColor: "#D3D3D3",
    }}/>
  );
};

const BoostSelfAddBills = ({
  selectedBill,
  handleSelectedBill,
  dynamicItemsMaxHeight,
  transactions,
  handleDontSeePayment,
}) => {

  return (
    <>
      <div className="flex flex-col w-5/6 mx-auto">
        <h1 className="text-center mt-2">Select A Bill</h1>
        <p className="text-m"><b>Payments</b></p>
      </div>
      <div style={{ height: dynamicItemsMaxHeight }} className="bg-white mb-2 border-2 border-gray-400 w-5/6 mx-auto whitespace-normal overflow-y-auto rounded">
        { transactions.length && transactions.map((trans) => {
          const { posteddate, description, amount, id, source } = trans;
          const selectedClassBG = selectedBill?.id === id ? "bg-green-200" : "";

          return (
            <div className="flex rounded-lg w-full hover:bg-gray-200" key={id}>
              <button
                type="button"
                onClick={() => {
                  handleSelectedBill(trans);
                }}
                className={`w-full text-left ${selectedClassBG}`}
              >
                <div className="flex flex-col my-2 w-full px-2">
                  <div className="flex flex-row">
                    <div className="whitespace-nowrap w-full flex flex-row justify-between">
                      <div>{moment.unix(posteddate).format("MMM DD")}</div>
                      <div>{formatCurrency(amount)}</div>
                    </div>
                  </div>
                  <div className="flex flex-row ">source: {source}</div>
                  <div className="flex flex-row justify-end">
                    <i className="fa-solid fa-chevron-right" />
                  </div>
                  <div className="flex flex-row justify-between">
                    <div style={{ wordBreak: "break-word" }}>{description}</div>
                  </div>
                </div>
                {toThinLine()}
              </button>
            </div>
          );
        })
        }
      </div>
      <div className="flex flex-col w-5/6 mx-auto text-center pb-4 hover:text-boost-primary-purple">
        <button type="button" onClick={handleDontSeePayment}>
          Dont see your payment?
        </button>
      </div>
    </>
  );
};

export default BoostSelfAddBills;